// 学生状态管理模块
const state = {
  schedule: [],
  performance: []
};

const mutations = {
  SET_SCHEDULE(state, schedule) {
    state.schedule = schedule;
  },
  SET_PERFORMANCE(state, performance) {
    state.performance = performance;
  }
};

const actions = {
  fetchSchedule({ commit }) {
    // 模拟异步请求
    return new Promise(resolve => {
      setTimeout(() => {
        const schedule = [
          { id: 1, subject: '数学', day: '周一', time: '8:00-9:30', teacher: '李老师', room: '教室A101' },
          { id: 2, subject: '语文', day: '周一', time: '10:00-11:30', teacher: '王老师', room: '教室A101' },
          { id: 3, subject: '英语', day: '周二', time: '8:00-9:30', teacher: '张老师', room: '教室B201' },
          { id: 4, subject: '科学', day: '周三', time: '10:00-11:30', teacher: '赵老师', room: '实验室C302' }
        ];
        commit('SET_SCHEDULE', schedule);
        resolve(schedule);
      }, 500);
    });
  },
  fetchPerformance({ commit }) {
    // 模拟异步请求
    return new Promise(resolve => {
      setTimeout(() => {
        const performance = [
          { id: 1, subject: '数学', teacher: '李老师', rating: 5, comment: '解题思路清晰，逻辑性强', date: '2025-03-15' },
          { id: 2, subject: '语文', teacher: '王老师', rating: 4, comment: '作文有创意，但标点符号使用需要注意', date: '2025-03-14' },
          { id: 3, subject: '英语', teacher: '张老师', rating: 5, comment: '口语发音标准，积极参与课堂讨论', date: '2025-03-13' }
        ];
        commit('SET_PERFORMANCE', performance);
        resolve(performance);
      }, 500);
    });
  }
};

const getters = {
  schedule: state => state.schedule,
  performance: state => state.performance,
  averageRating: state => {
    if (state.performance.length === 0) return 0;
    const sum = state.performance.reduce((total, item) => total + item.rating, 0);
    return (sum / state.performance.length).toFixed(1);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}; 